import React from 'react';
import { StyleSheet, Text } from 'react-native';

import generateID from '../../utils/generate-id';

type Variant = 'success' | 'danger' | 'warning' | 'info';

type Props = {
  accessibilityLabel?: string;
  title: string;
  variant?: Variant;
  id?: string;
};

const Badge = (props: Props) => (
  <Text
    accessibilityLabel={props.accessibilityLabel}
    style={[
      style.root,
      props.variant === 'success' && style.variantSuccess,
      props.variant === 'danger' && style.variantDanger,
      props.variant === 'warning' && style.variantWarning,
      props.variant === 'info' && style.variantInfo,
    ]}
    /** Generate HTML and Test IDs  */
    {...generateID(props.id)}
  >
    {props.title}
  </Text>
);

const style = StyleSheet.create({
  root: {
    borderRadius: 4,
    padding: 4,
    fontSize: 12,
    fontWeight: 'bold',
    backgroundColor: '#EEF0F2',
  },
  variantSuccess: {
    backgroundColor: '#C8E696',
  },
  variantDanger: {
    backgroundColor: '#FF2751',
    color: 'white',
  },
  variantWarning: {
    backgroundColor: '#EBD4D4',
  },
  variantInfo: {
    backgroundColor: '#A6D2E4',
  },
});

export default Badge;
export { Props, Variant };
